import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { Route, NavLink, Link, BrowserRouter as Router, Switch } from 'react-router-dom'
import Home from './components/Home';
import Projects from './components/Projects';
import MSkill from './components/MSkill';
import WorkHistories from './components/WorkHistories';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import NotFoundPage from './components/NotFoundPage';

const routing = (
  <Router>
    {/* pakai flex flex-col 100vh agar footernya stay dibawah */}
    <div className={"flex flex-col"} style={{minHeight : "100vh"}}>
      <Navbar/>
      <div className={"pt-20 sm:pt-24 flex-1"}>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/projects" component={Projects} />
          <Route path="/skills" component={MSkill} />
          <Route path="/work_histories" component={WorkHistories} />
          <Route path="*" component={NotFoundPage} />  
        </Switch>          
      </div>
      <Footer/>
    </div>
  </Router>
)
ReactDOM.render(routing, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();